// extracted by mini-css-extract-plugin
module.exports = {"tips":"accountTips_tips__1nmtL","textWrapper":"accountTips_textWrapper__mNvsZ","icon":"accountTips_icon__3gKp1","text":"accountTips_text__jrKTC","btn":"accountTips_btn__2nKv6"};